import { Card, Carousel, Col, Container, Row } from "react-bootstrap";
import imageBorder from "../../assets/images/bestsellerborder.webp";
import reviewshape1 from "../../assets/images/reviewshape1.webp";
import reviewshape2 from "../../assets/images/reviewshapenew2.webp";
import reviewshape3 from "../../assets/images/reviewshape3.webp";
import Slider from "react-slick";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";
import axios from "axios";
import { BLOG_API } from "../../config/config";
import { chunk } from "lodash-es";
export const Homereview = () => {

    const [reviewsData, setReview] = useState([])


    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const handleClick = () => {
        window.open(
            "https://www.google.com/maps/place//data=!4m3!3m2!1s0x3be04fc7e837f0ef:0x61ef904bf9e5f6da!12e1?source=g.page.m.ia._&laa=nmx-review-solicitation-ia2",
            "_blank"
        );
    };



    useEffect(() => {
        const fetchBlogData = async () => {
            try {
                const response = await axios.post(BLOG_API);
                if (response.data.DATA) {
                    setReview(response.data.DATA[4].data)
                } else {
                    console.error("Unexpected API response structure:", response.data);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchBlogData()
    }, []);

    console.log(reviewsData)

    // Fetch Reviews From Google

    // Replace with your actual API key
    // const API_KEY = '';
    // const PLACE_ID = ''; // From your URL

    // useEffect(() => {
    //    const fetchPlaceReviews = async () => {
    //     try {
    //       // First, get place details including reviews
    //       const response = await fetch(
    //         `https://maps.googleapis.com/maps/api/place/details/json?place_id=${PLACE_ID}&fields=name,rating,reviews&key=${API_KEY}`
    //       );

    //       console.log(response)

    //       const data = await response.json();

    //       if (data.status === 'OK') {
    //         const place = data.result;
    //         console.log('Place Name:', place.name);
    //         console.log('Average Rating:', place.rating);
    //         console.log('Reviews:', place.reviews);

    //         // Process reviews here
    //         return place.reviews;
    //       } else {
    //         console.error('Error fetching place details:', data.status);
    //         return [];
    //       }
    //     } catch (error) {
    //       console.error('Error:', error);
    //       return [];
    //     }
    //   }
    //   console.log(fetchPlaceReviews())
    // }, [])



    // Function to chunk the reviews array into groups of 4

    const chunkArray = (array, chunkSize) => {
        const result = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    };

    // Split reviews into groups of 4 for each carousel item
    const reviewChunks = chunkArray(reviewsData, 4);


    console.log(reviewChunks)



    return (
        <div className="review-bg">
            <Container>
                <div
                    className="text-center fs-3 saree-heading pt-3 d-none d-sm-block"
                    data-aos="fade-up"
                >
                    Over 2500+ Satisfied Retails With a<br /> 5-Star Reviews
                </div>
                <div
                    className="text-center fs-3 saree-heading pt-3 d-block d-sm-none"
                    data-aos="fade-up"
                >
                    Over 2500+ Satisfied Retails With a 5-Star Reviews
                </div>

                <div className="d-flex justify-content-center">
                    <img
                        src={imageBorder}
                        alt="bestsellerborder"
                        className="pt-2 pb-3 border-image"
                    />
                </div>
                <Carousel
                    className=" d-none d-lg-block custom-bgcolor-change-carousel"
                    interval={null}
                >

                    {reviewChunks.map((chunks, chunkIndex) => (
                        <Carousel.Item key={chunkIndex}>
                            <div className="d-flex flex-column flex-lg-row justify-content-center gap-3 py-4">
                                {/* First Column - Always show first review if it exists */}
                                {chunks[0] && (
                                    <div className="d-flex flex-column flex-lg-column justify-content-center sm-review">
                                        <div className="d-none d-lg-flex justify-content-end review-shape-1" data-aos="fade-up-left">
                                            <img src={reviewshape1} alt="Review Shape 1" width={"50px"} />
                                        </div>
                                        <Card className="mb-3 p-3 theme-shadow rounded-5 border border-dark mt-3 card_style" style={{ width: "20rem", height: "17rem", overflow: "hidden" }}>
                                            <div className="d-flex">
                                                <div className="rounded-circle text-center">
                                                    <img style={{ width: '75px', height: '75px', objectFit: 'fill', borderRadius: '50%' }} src={chunks[0].profile_image} alt={chunks[0].username} />
                                                </div>
                                                <div className="p-3">
                                                    <Card.Title>{chunks[0].username}</Card.Title>
                                                    <Card.Text>
                                                        {[1, 2, 3, 4, 5].map((_, index) => (
                                                            <i key={index} className="bi bi-star-fill text-warning"></i>
                                                        ))}
                                                    </Card.Text>
                                                </div>
                                            </div>
                                            <div className="border-top my-2"></div>
                                            <Card.Text>{chunks[0].description}</Card.Text>
                                        </Card>
                                    </div>
                                )}

                                {/* Second Column - Only show if there are more than 1 reviews */}
                                {chunks.length > 1 && (
                                    <div className="d-flex flex-column sm-review">
                                        {/* Second Card */}
                                        {chunks[1] && (
                                            <Card className="mb-3 p-3 theme-shadow rounded-5 border border-dark card_style" style={{ width: "20rem", height: "17rem", overflow: "hidden" }}>
                                                <div className="d-flex">
                                                    <div className="rounded-circle text-center">
                                                        <img style={{ width: '75px', height: '75px', objectFit: 'fill', borderRadius: '50%' }} src={chunks[1].profile_image} alt={chunks[1].username} />
                                                    </div>
                                                    <div className="p-3">
                                                        <Card.Title>{chunks[1].username}</Card.Title>
                                                        <Card.Text>
                                                            {[1, 2, 3, 4, 5].map((_, index) => (
                                                                <i key={index} className="bi bi-star-fill text-warning"></i>
                                                            ))}
                                                        </Card.Text>
                                                    </div>
                                                </div>
                                                <div className="border-top my-2"></div>
                                                <Card.Text>{chunks[1].description}</Card.Text>
                                            </Card>
                                        )}

                                        {/* Third Card - Only show if there are more than 2 reviews */}
                                        {chunks.length > 2 && chunks[2] && (
                                            <Card className="mb-3 p-3 theme-shadow rounded-5 border border-dark card_style" style={{ width: "20rem", height: "17rem", overflow: "hidden" }}>
                                                <div className="d-flex">
                                                    <div className="rounded-circle text-center">
                                                        <img style={{ width: '75px', height: '75px', objectFit: 'fill', borderRadius: '50%' }} src={chunks[2].profile_image} alt={chunks[2].username} />
                                                    </div>
                                                    <div className="p-3">
                                                        <Card.Title>{chunks[2].username}</Card.Title>
                                                        <Card.Text>
                                                            {[1, 2, 3, 4, 5].map((_, index) => (
                                                                <i key={index} className="bi bi-star-fill text-warning"></i>
                                                            ))}
                                                        </Card.Text>
                                                    </div>
                                                </div>
                                                <div className="border-top my-2"></div>
                                                <Card.Text>{chunks[2].description}</Card.Text>
                                            </Card>
                                        )}
                                    </div>
                                )}

                                {/* Third Column - Only show if there are 4 reviews */}
                                {chunks.length > 3 && chunks[3] && (
                                    <div className="d-flex flex-column sm-review">
                                        <div className="d-none d-lg-flex justify-content-lg-start align-items-start mb-3 mt-lg-3" data-aos="fade-up-left">
                                            <img src={reviewshape3} alt="Review Shape 3" width={"50px"} />
                                        </div>
                                        <Card className="mb-3 p-3 theme-shadow rounded-5 border border-dark card_style" style={{ width: "20rem", height: "17rem", overflow: "hidden" }}>
                                            <div className="d-flex">
                                                <div className="rounded-circle text-center">
                                                    <img style={{ width: '75px', height: '75px', objectFit: 'fill', borderRadius: '50%' }} src={chunks[3].profile_image} alt={chunks[3].username} />
                                                </div>
                                                <div className="p-3">
                                                    <Card.Title>{chunks[3].username}</Card.Title>
                                                    <Card.Text>
                                                        {[1, 2, 3, 4, 5].map((_, index) => (
                                                            <i key={index} className="bi bi-star-fill text-warning"></i>
                                                        ))}
                                                    </Card.Text>
                                                </div>
                                            </div>
                                            <div className="border-top my-2"></div>
                                            <Card.Text>{chunks[3].description}</Card.Text>
                                        </Card>
                                        <div className="d-none d-lg-flex justify-content-lg-start" data-aos="fade-left">
                                            <img src={reviewshape2} alt="ReviewShape2" width={"50px"} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>

                {/* ========================================================================================================================================== */}

                <Slider {...settings} className="d-block d-lg-none ">
                    {reviewsData.map((review, index) => (
                        <div key={index} className="d-flex justify-content-center">
                            <Card
                                className="mb-3 p-3 theme-shadow rounded-5 border border-dark mt-3 card_style"
                                style={{ width: "20rem", height: "250px", overflow: "hidden" }}
                            >
                                <div className="d-flex">
                                    <div
                                        className="rounded-circle text-center"
                                    >
                                        <div className="rounded-circle text-center">
                                            <img style={{ width: '75px', height: '75px', objectFit: 'fill', borderRadius: '50%' }} src={review.profile_image} alt={review.username} />
                                        </div>
                                    </div>
                                    <div className="p-3">
                                        <Card.Title className="review_name">{review.username}</Card.Title>
                                        <Card.Text>
                                            {[...Array(review.rating)].map((_, i) => (
                                                <i key={i} className="bi bi-star-fill text-warning"></i>
                                            ))}
                                        </Card.Text>
                                    </div>
                                </div>
                                <div className="border-top border_card my-2"></div>
                                <div
                                    style={{
                                        maxHeight: "100px",
                                        overflow: "scroll",
                                        scrollbarWidth: "none",
                                    }}
                                >
                                    <Card.Text className="card_review" style={{ height: "100px", overflow: "scroll", scrollbarWidth: 'none' }}>{review.description}</Card.Text>
                                </div>
                            </Card>
                        </div>
                    ))}
                </Slider>

                <div className="text-center my-3">
                    <span className="cst-rvw-text px-2">
                        Want to share your experience?
                    </span>
                    <button
                        className="cst-rvw-btn rounded-5 btn-red-to-black-color-move help-btn"
                        onClick={handleClick}
                    >
                        <span>Write Review</span>
                    </button>
                </div>
            </Container>
        </div>
    );
};
